import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { MapContentComponent } from './components/map-content.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        MapContentComponent,
    ],
    schemas: [
        NO_ERRORS_SCHEMA,
    ],
    exports: [
        MapContentComponent,
    ],
})

export class MapContentModule {}
